import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { SaleDocumentKind } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ClientLinks {
    readonly documents: ClientDocumentLink[];
}

export interface ClientDocumentLink {
    readonly documentId: number;
    readonly documentNumber: string;
    readonly kind: SaleDocumentKind;
    readonly version: string;
}

export class ClientLinksQuery extends Query<ClientLinks> {
    public constructor(public readonly clientId: number) {
        super();
    }
}

export class ClientLinksQueryHandlerBase implements QueryHandler<ClientLinksQuery> {
    private static Url = TaggedUrl.join('clients/:id/links', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(query: ClientLinksQuery): Promise<ClientLinks> {
        const url = fillPlaceholders(ClientLinksQueryHandlerBase.Url, { id: query.clientId });
        const { data } = await this.$http.get<ClientLinks>(url);
        return {
            documents: data.documents?.map(this.mapDocument) ?? []
        };
    }

    private mapDocument(data: any): ClientDocumentLink {
        return {
            documentId: data.id,
            documentNumber: data.documentNumber,
            kind: data.kind,
            version: data.version
        };
    }
}
